import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { adminAuthAPI } from '../lib/api';
import { useDispatch } from 'react-redux';
import { logout as logoutUser, setAdminUser } from '../features/userSlice';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      setLoading(false);
      return;
    }

    adminAuthAPI.getProfile()
      .then((res) => {
        const currentAdmin = res.data?.admin || null;
        setIsAuthenticated(true);
        setAdmin(currentAdmin);
        if (currentAdmin) {
          dispatch(setAdminUser({ ...currentAdmin, token }));
        }
      })
      .catch(() => {
        localStorage.removeItem('adminToken');
        setIsAuthenticated(false);
        setAdmin(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await adminAuthAPI.login(email, password);
    const token = res.data?.token;
    if (!token) throw new Error('No token returned');
    localStorage.setItem('adminToken', token);

    const profile = await adminAuthAPI.getProfile();
    const currentAdmin = profile.data?.admin || null;
    setAdmin(currentAdmin);
    setIsAuthenticated(true);
    if (currentAdmin) {
      dispatch(setAdminUser({ ...currentAdmin, token }));
    }
    return currentAdmin;
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    setAdmin(null);
    setIsAuthenticated(false);
    dispatch(logoutUser());
  };

  const value = useMemo(() => ({
    isAuthenticated,
    loading,
    admin,
    login,
    logout
  }), [isAuthenticated, loading, admin]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
